import { combineReducers } from "redux";
import {
  logout_user_reducer,
  get_user_reducer,

  //master
  fetch_companies_reducer,
  fetch_user_contacts_reducer,
  fetch_user_contact_details_reducer,

  // organisation
  get_organisation_users_reducer,
  get_organisation_reducer,

  //category
  fetch_categories_reducer,

  // microsoft
  check_microsoft_auth_reducer,
  fetch_microsoft_email_threads_reducer,
} from "./reducer";

const rootReducer = combineReducers({
  logout_user_reducer,
  get_user_reducer,

  fetch_companies_reducer,

  fetch_user_contacts_reducer,
  fetch_user_contact_details_reducer,

  // organisation
  get_organisation_users_reducer,
  get_organisation_reducer,

  //category
  fetch_categories_reducer,

  // microsoft
  check_microsoft_auth_reducer,
  fetch_microsoft_email_threads_reducer,
});

export default rootReducer;
